import Model from "./Model";
import LanguageTranslation from './LanguageTranslation';
import {ClassTransformOptions, plainToClass, Type} from "class-transformer";

class Language extends Model {

    id: number;
    code: string;
    @Type(() => Date)
    created_at: Date;
    @Type(() => Date)
    updated_at: Date;


    /*
    |--------------------------------------------------------------------------
    | Reflection
    |--------------------------------------------------------------------------
    */

    /**
     * Gets class name
     * survives minification/uglification
     *
     * @return {string}
     */
    getClassName(): string {
        return 'Language';
    }


    /*
    |--------------------------------------------------------------------------
    | Relationships
    |--------------------------------------------------------------------------
    */

    @Type(() => LanguageTranslation)
    translation: LanguageTranslation;

    @Type(() => LanguageTranslation)
    translations: LanguageTranslation[];


    /*
    |--------------------------------------------------------------------------
    | Methods
    |--------------------------------------------------------------------------
    */

    name(locale?: string): string {
        return (this as any).translateOrDefault(locale)?.name;
    }

    /**
     * Converts plain (literal) object to class (constructor) object. Also works with arrays.
     */
     static new(plain: [], options?: ClassTransformOptions): Language[];
     static new(plain: {}, options?: ClassTransformOptions): Language;
     static new(plain: {} | [], options?: ClassTransformOptions): Language | Language[] {
         return plainToClass(Language, plain as any, options);
     }
}

export default Language;
